// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.addBtn {
  padding: 5px 10px;
  background-color: #8fd091;
  color: #fff;
  margin-right: 15px;
  margin-bottom: 5px;
  border-top-left-radius: 8px;
  border-bottom-right-radius: 8px;
}
.titleWrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.titleWrapper h2 {
  font-weight: 600;
  font-size: 22px;
}
.titleWrapper button {
  padding: 5px 15px;
  background-color: #8fd091;
  color: #fff;
  border: none;
  border-top-left-radius: 8px;
  border-bottom-right-radius: 8px;
}

.formWrapper {
  margin-top: 10px;
  padding: 20px;
  background-color: #fff;
  border-radius: 10px;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  display: grid;
  gap: 20px;
  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
}
.formWrapperTwo {
  margin-top: 10px;
  padding: 100px;
  background-color: #fff;
  border-radius: 10px;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  gap: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 700px;
}

.submitBtnWrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 10px;
}

.submitBtnWrapper button {
  padding: 10px 20px;
  background-color: #8fb6d0;
  color: #fff;
  border: none;
  border-top-left-radius: 8px;
  border-bottom-right-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
}
.submitBtnWrapper button:hover {
  background-color: #334b5b;
}
`, "",{"version":3,"sources":["webpack://./src/views/admin/masterRemedy/masterRemedy.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,2BAA2B;EAC3B,+BAA+B;AACjC;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,iDAAiD;EACjD,aAAa;EACb,SAAS;EACT,2DAA2D;AAC7D;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,mBAAmB;EACnB,iDAAiD;EACjD,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,yBAAyB;AAC3B","sourcesContent":[".addBtn {\n  padding: 5px 10px;\n  background-color: #8fd091;\n  color: #fff;\n  margin-right: 15px;\n  margin-bottom: 5px;\n  border-top-left-radius: 8px;\n  border-bottom-right-radius: 8px;\n}\n.titleWrapper {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.titleWrapper h2 {\n  font-weight: 600;\n  font-size: 22px;\n}\n.titleWrapper button {\n  padding: 5px 15px;\n  background-color: #8fd091;\n  color: #fff;\n  border: none;\n  border-top-left-radius: 8px;\n  border-bottom-right-radius: 8px;\n}\n\n.formWrapper {\n  margin-top: 10px;\n  padding: 20px;\n  background-color: #fff;\n  border-radius: 10px;\n  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;\n  display: grid;\n  gap: 20px;\n  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));\n}\n.formWrapperTwo {\n  margin-top: 10px;\n  padding: 100px;\n  background-color: #fff;\n  border-radius: 10px;\n  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;\n  gap: 20px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  width: 700px;\n}\n\n.submitBtnWrapper {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: 10px;\n}\n\n.submitBtnWrapper button {\n  padding: 10px 20px;\n  background-color: #8fb6d0;\n  color: #fff;\n  border: none;\n  border-top-left-radius: 8px;\n  border-bottom-right-radius: 8px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n}\n.submitBtnWrapper button:hover {\n  background-color: #334b5b;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
